// import React from "react";
// import { useRef,useState,useEffect } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import apiClient from "../../api/axiosClient";
// import "../../styles/scoretable.css";


// const ENDPOINT = "/vw-hrm-scores/";
// const HRMscoretable = () => {
//   const tableRef = useRef();
//   const [apiData, setApiData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await apiClient.get(ENDPOINT);
//         setApiData(response.data.results || []); 
//         setLoading(false);
//       } catch (err) {
//         console.error("API error:", err);
//         setError("Failed to fetch data from API");
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>{error}</div>;


//   const companies = apiData.map(item => item.organisation_name);

//   const learning_development_score = apiData.map(item => item.learning_development_score);
//   const total_no_of_training_score = apiData.map(item => item.total_no_training_days_score);
//   const gm = apiData.map(item => item.ldGM);
//   const gm_score = apiData.map(item => item.ldGM_score);
//   const executive_score = apiData.map(item => item.ldExecutive_score);
//   const executive = apiData.map(item => item.ldExecutive);
//   const workmen_score = apiData.map(item => item.ldWorkmen_score);
//   const workmen = apiData.map(item => item.ldWorkmen);
//   const hse_score = apiData.map(item => item.HSE_training_days_score);
//   const hse = apiData.map(item => item.ldHSE);
//   const no_of_training_hse_score = apiData.map(item => item.no_of_training_days_hse_score);
  
  
//   const skill_score = apiData.map(item => item.ldSkill_score);
//   const skill = apiData.map(item => item.ldSkill);
//   const functional_score = apiData.map(item => item.ldFunctional_score);
//   const functional =apiData.map(item => item.ldFunctional);
//   const management_score = apiData.map(item => item.ldManagement_score);
//   const management = apiData.map(item => item.ldManagement);
  
  

//   const attrition_rate_score = apiData.map(item => item.employee_attrition_rate_score);
//   const entry_level_attrition_score = apiData.map(item => item.attritionEntry_score);
//   const entry_level = apiData.map(item => item.attritionEntry);
//   const executive_attrition_score = apiData.map(item => item.attritionExecutive_score);
//   const executive_attrition = apiData.map(item => item.attritionExecutive);
//   const senior_attrition_score = apiData.map(item => item.attritionSenior_score);
//   const senior_attrition = apiData.map(item => item.attritionSenior);
 
 
//   const recruitment_score = apiData.map(item => item.recruitment_percent_score);
//   const total_vacancies = apiData.map(item => item.recruitVacancies);
//   const total_positions_score = apiData.map(item => item.total_vacancies_position_percent);
//   const total_positions = apiData.map(item => item.recruitFilled);
//   const recruitment_cycle_score = apiData.map(item => item.recruitement_cycle_completion_score);
//   const recruitment_cycle = apiData.map(item => item.recruitCycle);
  

  
//   const diverse_workforce_score = apiData.map(item => item.diverse_workforce_score);
//   const total_no_of_employees = apiData.map(item => item.diversityTotal);
//   const young_employees_score = apiData.map(item => item.percentage_young_employee_score);
//   const no_of_employees_under40 = apiData.map(item => item.diversityUnder40);
//   const no_of_employees_under40_percent = apiData.map(item => item.age_of_employees_under_40);
//   const no_of_female_employees_score = apiData.map(item => item.female_employees_score);
//   const no_of_female_employees = apiData.map(item => item.diversityFemale);
//   const no_of_female_employees_percent = apiData.map(item => item.female_employees_percent);
//   const no_of_employees_higher_score =apiData.map(item => item.employees_higher_qualification_score);
//   const no_of_employees_higher = apiData.map(item => item.diversityQualified);
//   const no_of_employees_higher_percent = apiData.map(item => item.employees_higher_qualification);
  
  
//   const growth_differently_abled = apiData.map(item => item.growth_in_differently_abled_employees_score);
//   const no_differently_abled_prev = apiData.map(item => item.diversityDisabled2023);
//   const no_differently_abled_assessment = apiData.map(item => item.diversityDisabled2024);
//   const differently_abled_percent = apiData.map(item => item.no_differently_abled_employees_percent);
  
  
//   const PME_score = apiData.map(item => item.preventive_medical_examination_score);
//   const PME_percent = apiData.map(item => item.no_of_undergone_PME_percent);
//   const no_of_undergone_PME = apiData.map(item => item.pmeDone);
//   const no_of_employees_PME = apiData.map(item => item.pmeRequired);
//   const female_workforce_score = apiData.map(item => item.progress_retaining_female_workforce_score);
//   const no_of_female_employees_workforce = apiData.map(item => item.retentionFemalePast);
//   const female_workforce_percent = apiData.map(item => item.female_employees_5_years_percent);
  
 
//   const Grievance2 = apiData.map(item => item.grievanceMechanism2);
//   const Award2 = apiData.map(item => item.employeeAwards2);
 
 
//   const Total_score = apiData.map(item => item.total_hrm_score);

// const safeFmt = (v, digits = 2) => {
//     if (v === null || v === undefined || v === "") return "-";
//     // If it's already a number and finite, format it
//     if (typeof v === "number" && Number.isFinite(v)) {
//       return v.toFixed(digits);
//     }
//     // Try convert numeric strings
//     const num = Number(v);
//     if (!Number.isNaN(num) && Number.isFinite(num)) {
//       // return fixed digits (or integer if digits === 0)
//       return digits === 0 ? String(Math.round(num)) : num.toFixed(digits);
//     }
//     try {
//       return String(v);
//     } catch {
//       return "-";
//     }
//   };

//   const handleExport = () => {
//     const table = tableRef.current;
//     const wb = XLSX.utils.table_to_book(table, { sheet: "HRM Scores" });
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), "HRM_Scores.xlsx");
//   };

// return (
//     <div className="table-box">
//       <button
//         onClick={handleExport } className="export-btn"
        
//       >
//         Export to Excel
//       </button>
//       <table ref={tableRef} className="min-w-full border border-gray-300 shadow-md rounded-lg">
//         <thead className="bg-blue-600 text-white">
//           <tr>
//             <th className="border px-3 py-2 cursor-pointer">S.No.</th>
//             <th className="border px-3 py-2 cursor-pointer">Criteria</th>
//             <th className="border px-3 py-2 cursor-pointer">Unit</th>
//             <th className="border px-3 py-2 cursor-pointer">Marks</th>
//             <th className="border px-3 py-2 cursor-pointer"></th>
          
//             {companies.map((company) => (
//               <th key={company} className="border px-3 py-2 cursor-pointer">
//                 {company}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="bg-white">
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1</td>
//             <td className="border px-3 py-2">
//               <strong>Learning & Development Score</strong>
//             </td>
//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">22</td>
//             <td className="border px-3 py-2"></td>
           
//             {learning_development_score.map((s, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {s.toFixed(2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">
//               <strong>Total no. of training days imparted to such employees/no. of such employees at the mentioned level Score
//             </strong></td>
//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2"></td>
          
//             {total_no_of_training_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.1</td>
//          <td className="border px-3 py-2" >
//          GM and above
//          </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {gm.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {gm_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//  <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.2</td>
//          <td className="border px-3 py-2" >
//        Executive(up to E-6 level in PSU or equivalent)
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {executive.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {executive_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.3</td>
//          <td className="border px-3 py-2" >
//        Workmen
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {workmen.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {workmen_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.4</td>
//          <td className="border px-3 py-2" >
//        <strong>HSE training days per employee Score</strong>
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {hse_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
        
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {hse.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.5</td>
//          <td className="border px-3 py-2" >
//       <strong>No. of training days (excluding HSE) per employee for each of the following Score</strong>
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_training_hse_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Skill Development Training
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {skill.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {skill_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
          
          
          
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.5.2</td>
//          <td className="border px-3 py-2" >
//        Functional/On-job Training
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {functional.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {functional_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">1.5.3</td>
//          <td className="border px-3 py-2" >
//        Management Training
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {management.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {management_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2</td>
//          <td className="border px-3 py-2" >
//        <strong>Employee attrition rate (other than retirement) Score</strong>
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2"></td>
           
//             {attrition_rate_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.1</td>
//          <td className="border px-3 py-2" >
//         Entry level (within first two years of joining)
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {entry_level.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {entry_level_attrition_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.2</td>
//          <td className="border px-3 py-2" >
//        Executives (up to E-6 level in PSU or equivalent)
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {executive_attrition.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {executive_attrition_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">2.3</td>
//          <td className="border px-3 py-2" >
//        Senior Management
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {senior_attrition.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {senior_attrition_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3</td>
//          <td className="border px-3 py-2" >
//        <strong>% Recruitment (full-time ; regular employees) Score </strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">15</td>
//             <td className="border px-3 py-2"></td>
           
//             {recruitment_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3.1</td>
//          <td className="border px-3 py-2" >
//         Total vacancies identified for recruitment to be done during the year
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {total_vacancies.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> 
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">3.2</td>
//          <td className="border px-3 py-2" >
//         Total no. of positions filled during  the year through hiring
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {total_positions.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr> 
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//         Score
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {total_positions_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">4</td>
//          <td className="border px-3 py-2" >
//        <strong>Recruitement Cycle Completion Score </strong>
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {recruitment_cycle_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        Avg. no. of days from when the job requisition was received until the offer was accepted by the candidate
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {recruitment_cycle.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5</td>
//          <td className="border px-3 py-2" >
//         <strong>Diverse workforce (as on 31st March) Score</strong>
//        </td>

//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">20</td>
//             <td className="border px-3 py-2"></td>
           
//             {diverse_workforce_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        Total no. of employees 
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {total_no_of_employees.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.1</td>
//          <td className="border px-3 py-2" >
//        <strong>Percentage young employees Score</strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {young_employees_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        No. of Employees under 40 years 
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_employees_under40.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        % age of employees who are under 40 years
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_employees_under40_percent.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//  <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.2</td>
//          <td className="border px-3 py-2" >
//        <strong>% Female employees Score</strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_female_employees_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        No. of female employees
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_female_employees.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        % female employees
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_female_employees_percent.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.3</td>
//          <td className="border px-3 py-2" >
//        <strong>% employees having higher qualification (post graduates & above) Score</strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_employees_higher_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        No. of Employees having  higher qualification (post graduates & above)
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_employees_higher.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
       
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_employees_higher_percent.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">5.4</td>
//          <td className="border px-3 py-2" >
//        <strong>% Growth in differently-abled employement (as on 31st March) Score</strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {growth_differently_abled.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        % female employeesNo. of differently-abled employees during previous year</td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_differently_abled_prev.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        No. of differently-abled employees during assessment year
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_differently_abled_assessment.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        increase
//        </td>

//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {differently_abled_percent.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">6</td>
//          <td className="border px-3 py-2" >
//        <strong>Preventive Medical Examination (PME) Score</strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {PME_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">6.1</td>
//          <td className="border px-3 py-2" >
//        No. of undergone PME in current year
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_undergone_PME.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">6.2</td>
//          <td className="border px-3 py-2" >
//        No. of employees who were to undergo PME as per company policy during the year
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_employees_PME.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//  <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">6.2</td>
//          <td className="border px-3 py-2" >
       
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {PME_percent.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>

//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">7</td>
//          <td className="border px-3 py-2" >
//        <strong>Progress in Retaining Female Workforce Score</strong>
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {female_workforce_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        No. of Female employees 5 Years Ago
//        </td>

//             <td className="border px-3 py-2">No.</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {no_of_female_employees_workforce.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//          <td className="border px-3 py-2" >
//        Increase
//        </td>

//             <td className="border px-3 py-2">%</td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
           
//             {female_workforce_percent.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {safeFmt(v, 2)}
//               </td>
//             ))}
//           </tr>
//            <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">8</td>
//          <td className="border px-3 py-2" >
//        <strong>Grievance Redressal Mechanism (Does the company provide a channel through which employees can report suspected grievances, and does the channel allow for confidential and/or anonymous reporting - Yes/No. If yes, provide details in bullet points - Within 300 words) Score</strong>
//        </td>

//             <td className="border px-3 py-2">Write-up</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {Grievance2.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>
//           <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2">9</td>
//          <td className="border px-3 py-2" >
//        <strong>Recognition & Award Programmes for Employees (Details in bullet points of awards/recognitions programmes active within the organization for employees in the year 2024-25 : Within 300 words) Score</strong>
//        </td>

//             <td className="border px-3 py-2">Write-up</td>
//             <td className="border px-3 py-2">5</td>
//             <td className="border px-3 py-2"></td>
           
//             {Award2.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {/* {safeFmt(v, 2)} */}
//               </td>
//             ))}
//           </tr>

           
//               <tr className="hover:bg-gray-100">
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"><strong>Total</strong></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2"></td>
//             <td className="border px-3 py-2">100.00</td>
           
//             {Total_score.map((v, i) => (
//               <td key={i} className="border px-3 py-2">
//                 {v.toFixed(2)}
//               </td>
//             ))}
//           </tr>

//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default HRMscoretable;







import React, { useRef, useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import apiClient from "../../api/axiosClient";
import "../../styles/scoretable.css";

const ENDPOINT = "/vw-hrm-scores/";

const HRMscoretable = () => {
  const tableRef = useRef();
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);



       const safeFmt = (v, digits = 2) => {
    if (v === null || v === undefined || v === "") return "-";
    // If it's already a number and finite, format it
    if (typeof v === "number" && Number.isFinite(v)) {
      return v.toFixed(digits);
    }
    // Try convert numeric strings
    const num = Number(v);
    if (!Number.isNaN(num) && Number.isFinite(num)) {
      // return fixed digits (or integer if digits === 0)
      return digits === 0 ? String(Math.round(num)) : num.toFixed(digits);
    }
    try {
      return String(v);
    } catch {
      return "-";
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get(ENDPOINT);
        setApiData(response.data.results || []);
        setLoading(false);
      } catch (err) {
        console.error("API error:", err);
        setError("Failed to fetch data from API");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  // Map API data to arrays
  const companies = apiData.map(item => item.organisation_name);
  const learning_development_score = apiData.map(item => item.learning_development_score);
  const total_no_of_training_score = apiData.map(item => item.total_no_training_days_score);
  const gm = apiData.map(item => item.ldGM);
  const gm_score = apiData.map(item => item.ldGM_score);
  const executive_score = apiData.map(item => item.ldExecutive_score);
  const executive = apiData.map(item => item.ldExecutive);
  const workmen_score = apiData.map(item => item.ldWorkmen_score);
  const workmen = apiData.map(item => item.ldWorkmen);
  const hse_score = apiData.map(item => item.installed_capacity_2024);
  const hse = apiData.map(item => item.ldHSE);
  const no_of_training_hse_score = apiData.map(item => item.HSE_training_days_score);
  const skill_score = apiData.map(item => item.ldSkill_score);
  const skill = apiData.map(item => item.ldSkill);
  const functional_score = apiData.map(item => item.ldFunctional_score);
  const functional = apiData.map(item => item.ldFunctional);
  const management_score = apiData.map(item => item.ldManagement_score);
  const management = apiData.map(item => item.ldManagement);
  const attrition_rate_score = apiData.map(item => item.employee_attrition_rate_score);
  const entry_level_attrition_score = apiData.map(item => item.attritionEntry_score);
  const entry_level = apiData.map(item => item.attritionEntry);
  const executive_attrition_score = apiData.map(item => item.attritionExecutive_score);
  const executive_attrition = apiData.map(item => item.attritionExecutive);
  const senior_attrition_score = apiData.map(item => item.attritionSenior_score);
  const senior_attrition = apiData.map(item => item.attritionSenior);
  const recruitment_score = apiData.map(item => item.recruitment_percent_score);
  const total_vacancies = apiData.map(item => item.recruitVacancies);
  const total_positions_score = apiData.map(item => item.total_vacancies_position_percent);
  const total_positions = apiData.map(item => item.recruitFilled);
  const recruitment_cycle_score = apiData.map(item => item.recruitement_cycle_completion_score);
  const recruitment_cycle = apiData.map(item => item.recruitCycle);
  const diverse_workforce_score = apiData.map(item => item.diverse_workforce_score);
  const total_no_of_employees = apiData.map(item => item.diversityTotal);
  const young_employees_score = apiData.map(item => item.percentage_young_employee_score);
  const no_of_employees_under40 = apiData.map(item => item.diversityUnder40);
  const no_of_employees_under40_percent = apiData.map(item => item.age_of_employees_under_40);
  const no_of_female_employees_score = apiData.map(item => item.female_employees_score);
  const no_of_female_employees = apiData.map(item => item.diversityFemale);
  const no_of_female_employees_percent = apiData.map(item => item.female_employees_percent);
  const no_of_employees_higher_score = apiData.map(item => item.employees_higher_qualification_score);
  const no_of_employees_higher = apiData.map(item => item.diversityQualified);
  const no_of_employees_higher_percent = apiData.map(item => item.employees_higher_qualification);
  const growth_differently_abled = apiData.map(item => item.growth_in_differently_abled_employees_score);
  const no_differently_abled_prev = apiData.map(item => item.diversityDisabled2023);
  const no_differently_abled_assessment = apiData.map(item => item.diversityDisabled2024);
  const differently_abled_percent = apiData.map(item => item.no_differently_abled_employees_percent);
  const PME_score = apiData.map(item => item.preventive_medical_examination_score);
  const PME_percent = apiData.map(item => item.installed_capacity_2024);
  const no_of_undergone_PME = apiData.map(item => item.pmeDone);
  const no_of_employees_PME = apiData.map(item => item.pmeRequired);
  const female_workforce_score = apiData.map(item => item.progress_retaining_female_workforce_score);
  const no_of_female_employees_workforce = apiData.map(item => item.retentionFemalePast);
  const female_workforce_percent = apiData.map(item => item.installed_capacity_2024);
  const Grievance2 = apiData.map(item => item.grievanceMechanism2);
  const Award2 = apiData.map(item => item.employeeAwards2);
  const Total_score = apiData.map(item => item.total_hrm_score);

  // Helper function to compute formulas for a single company column
  const computeFormulasForColumn = (companyIndex, apiDataItem) => {
    const colData = new Array(56).fill(0); // Array for rows 1 to 55 (1-based indexing for simplicity)
    
    // Map API data to rows (adjust based on actual row mappings)
    // Assuming E and F are static or derived; replace with actual logic if available
    const E = new Array(56).fill(1); // Placeholder for column E (e.g., weights)
    const F = new Array(56).fill(1); // Placeholder for column F (e.g., denominators)
    
    // Map API fields to raw input rows (adjust based on your table structure)
    colData[6] = apiDataItem.ldGM || 0; // G6: GM
    colData[8] = apiDataItem.ldExecutive || 0; // G8: Executive
    colData[10] = apiDataItem.ldWorkmen || 0; // G10: Workmen
    colData[13] = apiDataItem.ldHSE || 0; // G13: HSE
    colData[15] = apiDataItem.ldSkill || 0; // G15: Skill
    colData[17] = apiDataItem.ldFunctional || 0; // G17: Functional
    colData[19] = apiDataItem.ldManagement || 0; // G19: Management
    colData[22] = apiDataItem.attritionEntry || 0; // G22: Entry Level Attrition
    colData[24] = apiDataItem.attritionExecutive || 0; // G24: Executive Attrition
    colData[26] = apiDataItem.attritionSenior || 0; // G26: Senior Attrition
    colData[29] = apiDataItem.recruitVacancies || 0; // G29: Total Vacancies
    colData[30] = apiDataItem.recruitFilled || 0; // G30: Total Positions Filled
    colData[33] = apiDataItem.recruitCycle || 0; // G33: Recruitment Cycle
    colData[35] = apiDataItem.diversityTotal || 0; // G35: Total Employees
    colData[37] = apiDataItem.diversityUnder40 || 0; // G37: Employees Under 40
    colData[40] = apiDataItem.diversityFemale || 0; // G40: Female Employees
    colData[43] = apiDataItem.diversityQualified || 0; // G43: Employees with Higher Qualification
    colData[46] = apiDataItem.diversityDisabled2023 || 0; // G46: Differently Abled Previous
    colData[47] = apiDataItem.diversityDisabled2024 || 0; // G47: Differently Abled Assessment
    colData[50] = apiDataItem.pmeDone || 0; // G50: PME Done
    colData[51] = apiDataItem.pmeRequired || 0; // G51: PME Required
    colData[54] = apiDataItem.retentionFemalePast || 0; // G54: Female Employees Past

    // Compute formula-based rows (in dependency order)
    colData[7] = Math.max(0, E[7] * colData[6] / (F[6] || 1)); // G7: MAX(0, $E7*G6/$F6)
    colData[9] = Math.max(0, E[9] * colData[8] / (F[8] || 1)); // G9: MAX(0, $E9*G8/$F8)
    colData[11] = Math.max(0, E[11] * colData[10] / (F[10] || 1)); // G11: MAX(0, $E11*G10/$F10)
    colData[5] = colData[7] + colData[9] + colData[11]; // G5: G7 + G9 + G11
    colData[12] = Math.max(0, E[12] * colData[13] / (F[13] || 1)); // G12: MAX(0, $E12*G13/$F13)
    colData[16] = Math.max(0, E[16] * colData[15] / (F[15] || 1)); // G16: MAX(0, $E16*G15/$F15)
    colData[18] = Math.max(0, E[18] * colData[17] / (F[17] || 1)); // G18: MAX(0, $E18*G17/$F17)
    colData[20] = Math.max(0, E[20] * colData[19] / (F[19] || 1)); // G20: MAX(0, $E20*G19/$F19)
    colData[14] = colData[16] + colData[18] + colData[20]; // G14: G16 + G18 + G20
    colData[4] = colData[5] + colData[12] + colData[14]; // G4: G5 + G12 + G14
    colData[23] = Math.max(0, E[23] / (colData[22] / (F[22] || 1))); // G23: MAX(0, $E23/(G22/$F22))
    colData[25] = Math.max(0, E[25] / (colData[24] / (F[24] || 1))); // G25: MAX(0, $E25/(G24/$F24))
    colData[27] = Math.max(0, E[27] / (colData[26] / (F[26] || 1))); // G27: MAX(0, $E27/(G26/$F26))
    colData[21] = colData[23] + colData[25] + colData[27]; // G21: G23 + G25 + G27
    colData[31] = (colData[30] / (colData[29] || 1)) * 100; // G31: G30/G29*100
    colData[28] = Math.max(0, E[28] * colData[31] / (F[31] || 1)); // G28: MAX(0, $E28*G31/$F31)
    colData[32] = Math.max(0, E[32] / (colData[33] / (F[33] || 1))); // G32: MAX(0, $E32/(G33/$F33))
    colData[38] = (colData[37] / (colData[35] || 1)) * 100; // G38: G37/G35*100
    colData[36] = Math.max(0, E[36] * colData[38] / (F[38] || 1)); // G36: MAX(0, $E36*G38/$F38)
    colData[41] = (colData[40] / (colData[35] || 1)) * 100; // G41: G40/G35*100
    colData[39] = Math.max(0, E[39] * colData[41] / (F[39] || 1)); // G39: MAX(0, $E39*G41/$F41)
    colData[44] = (colData[43] / (colData[35] || 1)) * 100; // G44: G43/G35*100
    colData[42] = Math.max(0, E[42] * colData[44] / (F[44] || 1)); // G42: MAX(0, $E42*G44/$F44)
    colData[48] = ((colData[47] - colData[46]) / (colData[46] || 1)) * 100; // G48: (G47-G46)/G46*100
    colData[45] = Math.max(0, E[45] * colData[48] / (F[48] || 1)); // G45: MAX(0, $E45*G48/$F48)
    colData[34] = colData[36] + colData[39] + colData[42] + colData[45]; // G34: G36 + G39 + G42 + G45
    colData[52] = (colData[50] / (colData[51] || 1)) * 100; // G52: G50/G51*100
    colData[49] = Math.max(0, E[49] * colData[52] / (F[52] || 1)); // G49: MAX(0, $E49*G52/$F52)
    colData[55] = ((colData[40] - colData[54]) / (colData[54] || 1)) * 100; // G55: (G40-G54)/G54*100
    colData[53] = Math.max(0, E[53] * colData[55] / (F[55] || 1)); // G53: MAX(0, $E53*G55/$F55)

    return colData;
  };

  // Modified handleExport function
  const handleExport = () => {
    // Define table structure (rows 1 to 55)
    const tableData = [
      ["S.No.", "Criteria", "Unit", "Marks", "", ...companies], // Header row
      ["1", "Learning & Development Score", "No.", "22", ""], // Row 1 (Row 4 in formulas)
      ["", "Total no. of training days imparted to such employees/no. of such employees at the mentioned level Score", "No.", "15", ""], // Row 2 (Row 5)
      ["1.1", "GM and above", "No.", "", ""], // Row 3 (Row 6)
      ["", "Score", "No.", "5", ""], // Row 4 (Row 7)
      ["1.2", "Executive (up to E-6 level in PSU or equivalent)", "No.", "", ""], // Row 5 (Row 8)
      ["", "Score", "No.", "5", ""], // Row 6 (Row 9)
      ["1.3", "Workmen", "No.", "", ""], // Row 7 (Row 10)
      ["", "Score", "No.", "5", ""], // Row 8 (Row 11)
      ["1.4", "HSE training days per employee Score", "No.", "5", ""], // Row 9 (Row 12)
      ["", "", "No.", "5", ""], // Row 10 (Row 13)
      ["1.5", "No. of training days (excluding HSE) per employee for each of the following Score", "No.", "15", ""], // Row 11 (Row 14)
      ["", "Skill Development Training", "No.", "", ""], // Row 12 (Row 15)
      ["", "Score", "No.", "5", ""], // Row 13 (Row 16)
      ["1.5.2", "Functional/On-job Training", "No.", "", ""], // Row 14 (Row 17)
      ["", "Score", "No.", "5", ""], // Row 15 (Row 18)
      ["1.5.3", "Management Training", "No.", "", ""], // Row 16 (Row 19)
      ["", "Score", "No.", "5", ""], // Row 17 (Row 20)
      ["2", "Employee attrition rate (other than retirement) Score", "No.", "15", ""], // Row 18 (Row 21)
      ["2.1", "Entry level (within first two years of joining)", "No.", "", ""], // Row 19 (Row 22)
      ["", "Score", "No.", "5", ""], // Row 20 (Row 23)
      ["2.2", "Executives (up to E-6 level in PSU or equivalent)", "No.", "", ""], // Row 21 (Row 24)
      ["", "Score", "No.", "5", ""], // Row 22 (Row 25)
      ["2.3", "Senior Management", "No.", "", ""], // Row 23 (Row 26)
      ["", "Score", "No.", "5", ""], // Row 24 (Row 27)
      ["3", "% Recruitment (full-time; regular employees) Score", "%", "15", ""], // Row 25 (Row 28)
      ["3.1", "Total vacancies identified for recruitment to be done during the year", "No.", "", ""], // Row 26 (Row 29)
      ["3.2", "Total no. of positions filled during the year through hiring", "No.", "", ""], // Row 27 (Row 30)
      ["", "Score", "%", "", ""], // Row 28 (Row 31)
      ["4", "Recruitment Cycle Completion Score", "No.", "5", ""], // Row 29 (Row 32)
      ["", "Avg. no. of days from when the job requisition was received until the offer was accepted by the candidate", "No.", "", ""], // Row 30 (Row 33)
      ["5", "Diverse workforce (as on 31st March) Score", "", "20", ""], // Row 31 (Row 34)
      ["", "Total no. of employees", "No.", "", ""], // Row 32 (Row 35)
      ["5.1", "Percentage young employees Score", "%", "5", ""], // Row 33 (Row 36)
      ["", "No. of Employees under 40 years", "No.", "", ""], // Row 34 (Row 37)
      ["", "% age of employees who are under 40 years", "%", "", ""], // Row 35 (Row 38)
      ["5.2", "% Female employees Score", "%", "5", ""], // Row 36 (Row 39)
      ["", "No. of female employees", "No.", "", ""], // Row 37 (Row 40)
      ["", "% female employees", "%", "", ""], // Row 38 (Row 41)
      ["5.3", "% employees having higher qualification (post graduates & above) Score", "%", "5", ""], // Row 39 (Row 42)
      ["", "No. of Employees having higher qualification (post graduates & above)", "No.", "", ""], // Row 40 (Row 43)
      ["", "", "%", "", ""], // Row 41 (Row 44)
      ["5.4", "% Growth in differently-abled employment (as on 31st March) Score", "%", "5", ""], // Row 42 (Row 45)
      ["", "No. of differently-abled employees during previous year", "No.", "", ""], // Row 43 (Row 46)
      ["", "No. of differently-abled employees during assessment year", "No.", "", ""], // Row 44 (Row 47)
      ["", "Increase", "", "", ""], // Row 45 (Row 48)
      ["6", "Preventive Medical Examination (PME) Score", "%", "5", ""], // Row 46 (Row 49)
      ["6.1", "No. of undergone PME in current year", "No.", "", ""], // Row 47 (Row 50)
      ["6.2", "No. of employees who were to undergo PME as per company policy during the year", "No.", "", ""], // Row 48 (Row 51)
      ["6.2", "", "%", "", ""], // Row 49 (Row 52)
      ["7", "Progress in Retaining Female Workforce Score", "%", "5", ""], // Row 50 (Row 53)
      ["", "No. of Female employees 5 Years Ago", "No.", "", ""], // Row 51 (Row 54)
      ["", "Increase", "%", "", ""], // Row 52 (Row 55)
      ["8", "Grievance Redressal Mechanism ... Score", "Write-up", "5", ""], // Row 53
      ["9", "Recognition & Award Programmes for Employees ... Score", "Write-up", "5", ""], // Row 54
      ["", "Total", "", "", "100.00"], // Row 55
    ];

    // Compute formula values for each company
    const computedData = apiData.map((item, index) => computeFormulasForColumn(index, item));

    // Add computed values to tableData
    for (let row = 0; row < tableData.length; row++) {
      const formulaRow = row + 4; // Adjust for formula rows (starting at G4)
      for (let col = 0; col < companies.length; col++) {
        if (formulaRow >= 4 && formulaRow <= 55) {
          tableData[row].push(computedData[col][formulaRow].toFixed(2));
        } else {
          tableData[row].push("");
        }
      }
    }
    // Create Excel workbook and sheet
    const ws = XLSX.utils.aoa_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "HRM Scores");

    // Export to Excel
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "HRM_Scores.xlsx");
  };

  return (
    <div className="table-box">
      <button
        onClick={handleExport} className="export-btn"
        
      >
        Export to Excel
      </button>
      <table ref={tableRef} className="min-w-full border border-gray-300 shadow-md rounded-lg">
        <thead className="bg-blue-600 text-white">
          <tr>
            <th className="border px-3 py-2 cursor-pointer">S.No.</th>
            <th className="border px-3 py-2 cursor-pointer">Criteria</th>
            <th className="border px-3 py-2 cursor-pointer">Unit</th>
            <th className="border px-3 py-2 cursor-pointer">Marks</th>
            <th className="border px-3 py-2 cursor-pointer"></th>
          
            {companies.map((company) => (
              <th key={company} className="border px-3 py-2 cursor-pointer">
                {company}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1</td>
            <td className="border px-3 py-2">
              <strong>Learning & Development Score</strong>
            </td>
            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">35</td>
            <td className="border px-3 py-2"></td>
           
            {learning_development_score.map((s, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(s, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">
              <strong>Total no. of training days imparted to such employees/no. of such employees at the mentioned level Score
            </strong></td>
            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">15</td>
            <td className="border px-3 py-2"></td>
          
            {total_no_of_training_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.1</td>
         <td className="border px-3 py-2" >
         GM and above
         </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {gm.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {gm_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

 <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.2</td>
         <td className="border px-3 py-2" >
       Executive(up to E-6 level in PSU or equivalent)
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {executive.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {executive_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.3</td>
         <td className="border px-3 py-2" >
       Workmen
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {workmen.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {workmen_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.4</td>
         <td className="border px-3 py-2" >
       <strong>HSE training days per employee Score</strong>
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {hse_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {hse.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.5</td>
         <td className="border px-3 py-2" >
      <strong>No. of training days (excluding HSE) per employee for each of the following Score</strong>
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">15</td>
            <td className="border px-3 py-2"></td>
           
            {no_of_training_hse_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Skill Development Training
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {skill.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {skill_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          
          
          
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.5.2</td>
         <td className="border px-3 py-2" >
       Functional/On-job Training
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {functional.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {functional_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">1.5.3</td>
         <td className="border px-3 py-2" >
       Management Training
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {management.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {management_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2</td>
         <td className="border px-3 py-2" >
       <strong>Employee attrition rate (other than retirement) Score</strong>
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">15</td>
            <td className="border px-3 py-2"></td>
           
            {attrition_rate_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.1</td>
         <td className="border px-3 py-2" >
        Entry level (within first two years of joining)
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {entry_level.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {entry_level_attrition_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.2</td>
         <td className="border px-3 py-2" >
       Executives (up to E-6 level in PSU or equivalent)
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {executive_attrition.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {executive_attrition_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">2.3</td>
         <td className="border px-3 py-2" >
       Senior Management
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {senior_attrition.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {senior_attrition_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3</td>
         <td className="border px-3 py-2" >
       <strong>% Recruitment (full-time ; regular employees) Score </strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {recruitment_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.1</td>
         <td className="border px-3 py-2" >
        Total vacancies identified for recruitment to be done during the year
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {total_vacancies.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> 
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">3.2</td>
         <td className="border px-3 py-2" >
        Total no. of positions filled during  the year through hiring
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {total_positions.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr> 
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
        Score
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {total_positions_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">4</td>
         <td className="border px-3 py-2" >
       <strong>Recruitement Cycle Completion Score </strong>
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {recruitment_cycle_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       Avg. no. of days from when the job requisition was received until the offer was accepted by the candidate
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {recruitment_cycle.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5</td>
         <td className="border px-3 py-2" >
        <strong>Diverse workforce (as on 31st March) Score</strong>
       </td>

            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">20</td>
            <td className="border px-3 py-2"></td>
           
            {diverse_workforce_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       Total no. of employees 
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {total_no_of_employees.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.1</td>
         <td className="border px-3 py-2" >
       <strong>Percentage young employees Score</strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {young_employees_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       No. of Employees under 40 years 
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_employees_under40.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       % age of employees who are under 40 years
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_employees_under40_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

 <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.2</td>
         <td className="border px-3 py-2" >
       <strong>% Female employees Score</strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {no_of_female_employees_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       No. of female employees
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_female_employees.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       % female employees
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_female_employees_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.3</td>
         <td className="border px-3 py-2" >
       <strong>% employees having higher qualification (post graduates & above) Score</strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {no_of_employees_higher_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       No. of Employees having  higher qualification (post graduates & above)
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_employees_higher.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_employees_higher_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">5.4</td>
         <td className="border px-3 py-2" >
       <strong>% Growth in differently-abled employement (as on 31st March) Score</strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {growth_differently_abled.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       % female employeesNo. of differently-abled employees during previous year</td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_differently_abled_prev.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       No. of differently-abled employees during assessment year
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_differently_abled_assessment.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
 <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       increase
       </td>

            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {differently_abled_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">6</td>
         <td className="border px-3 py-2" >
       <strong>Preventive Medical Examination (PME) Score</strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {PME_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">6.1</td>
         <td className="border px-3 py-2" >
       No. of undergone PME in current year
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_undergone_PME.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">6.2</td>
         <td className="border px-3 py-2" >
       No. of employees who were to undergo PME as per company policy during the year
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_employees_PME.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
 <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">6.2</td>
         <td className="border px-3 py-2" >
       
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {PME_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">7</td>
         <td className="border px-3 py-2" >
       <strong>Progress in Retaining Female Workforce Score</strong>
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {female_workforce_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       No. of Female employees 5 Years Ago
       </td>

            <td className="border px-3 py-2">No.</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {no_of_female_employees_workforce.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
         <td className="border px-3 py-2" >
       Increase
       </td>

            <td className="border px-3 py-2">%</td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"></td>
           
            {female_workforce_percent.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
           <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">8</td>
         <td className="border px-3 py-2" >
       <strong>Grievance Redressal Mechanism (Does the company provide a channel through which employees can report suspected grievances, and does the channel allow for confidential and/or anonymous reporting - Yes/No. If yes, provide details in bullet points - Within 300 words) Score</strong>
       </td>

            <td className="border px-3 py-2">Write-up</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {Grievance2.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>
          <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2">9</td>
         <td className="border px-3 py-2" >
       <strong>Recognition & Award Programmes for Employees (Details in bullet points of awards/recognitions programmes active within the organization for employees in the year 2024-25 : Within 300 words) Score</strong>
       </td>

            <td className="border px-3 py-2">Write-up</td>
            <td className="border px-3 py-2">5</td>
            <td className="border px-3 py-2"></td>
           
            {Award2.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

           
              <tr className="hover:bg-gray-100">
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2"><strong>Total</strong></td>
            <td className="border px-3 py-2"></td>
            <td className="border px-3 py-2">100</td>
            <td className="border px-3 py-2"></td>
           
            {Total_score.map((v, i) => (
              <td key={i} className="border px-3 py-2">
                {safeFmt(v, 2)}
              </td>
            ))}
          </tr>

        </tbody>
      </table>
    </div>
  );
};

export default HRMscoretable;
